"use client";

import TooltipWrapper from "@/components/layout/tooltip-wrapper";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import dynamic from "next/dynamic";
import { ReactNode, useState } from "react";
import LoadingFallback from "../layout/loading-fallback";
const FeedbackForm = dynamic(() => import("./feedback-form"), {
  ssr: false,
  loading: () => <LoadingFallback />
});
type FeedbackDialogProps = {
  children: ReactNode;
};
export default function FeedbackDialog({
  children
}: FeedbackDialogProps) {
  const [isOpen, setIsOpen] = useState(false);
  function closeDialog() {
    setIsOpen(false);
  }
  return <Dialog open={isOpen} onOpenChange={setIsOpen} data-sentry-element="Dialog" data-sentry-component="FeedbackDialog" data-sentry-source-file="feedback-dialog.tsx">
      <TooltipWrapper text="Give feedback" data-sentry-element="TooltipWrapper" data-sentry-source-file="feedback-dialog.tsx">
        <DialogTrigger asChild data-sentry-element="DialogTrigger" data-sentry-source-file="feedback-dialog.tsx">{children}</DialogTrigger>
      </TooltipWrapper>
      <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="feedback-dialog.tsx">
        <DialogHeader data-sentry-element="DialogHeader" data-sentry-source-file="feedback-dialog.tsx">
          <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="feedback-dialog.tsx">Give feedback</DialogTitle>
          <DialogDescription data-sentry-element="DialogDescription" data-sentry-source-file="feedback-dialog.tsx">Describe your question, problem or a suggestion</DialogDescription>
        </DialogHeader>

        <FeedbackForm closeDialogAction={closeDialog} data-sentry-element="FeedbackForm" data-sentry-source-file="feedback-dialog.tsx" />
      </DialogContent>
    </Dialog>;
}